import React, { memo } from 'react';
import {
  Text,
  DeleteConfirmationModal as DeleteConfirmationModalComp
} from '@shootsta/common-react';
import '../styles/_delete-confirmation-modal.scss';

type DeleteConfirmationModalProps = {
  deleteVideo: any;
  hideModal: any;
  onComplete: any;
  video?: Video;
};

const WARNINGS_LIST = [
  'All share links will be inaccessible',
  'All project comments and history will be archived',
  'All asset references will be removed'
];

const DeleteConfirmationModal = ({
  hideModal,
  video,
  deleteVideo,
  onComplete
}: DeleteConfirmationModalProps) => {
  if (!video) {
    return null;
  }

  const { videoId, name } = video;

  return (
    <DeleteConfirmationModalComp
      onDelete={deleteVideo}
      objectId={videoId}
      hideModal={hideModal}
      onComplete={onComplete}
      warnings={WARNINGS_LIST}
      title="Delete Video"
      subTitle="Are you sure you want to delete this video?"
    >
      <Text heading5>{name}</Text>
    </DeleteConfirmationModalComp>
  );
};

export default memo<DeleteConfirmationModalProps>(DeleteConfirmationModal);
